module.exports = __webpack_public_path__ + "static/media/kable.2ae35cb7.jpg";